module.exports = __webpack_public_path__ + "img/prescricao.482bb1de.svg";